import { LauncherElementData, TreeNode } from '../../hooks/stores/launcherElementsStore';

export const buildTree = (
  elements: {
    [key: string]: LauncherElementData;
  },
  structure: TreeNode[]
) => {
  const tree: TreeNode[] = [];

  structure.forEach((node) => {
    const elementData = elements[node.id];
    if (!elementData) return;

    const treeElement: TreeNode = {
      ...elementData,
    };

    if (node.children) {
      treeElement.props.children = buildTree(elements, node.children);
    }

    tree.push(treeElement);
  });

  return tree;
};
